<template>
    <div class="icon_config chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">图标</span>
            <el-dropdown class="updBtn" trigger="click">
                <i class="iconfont" style="font-size: 25px;color: #fff;cursor: pointer;" :class="config.name"></i>
                <el-dropdown-menu slot="dropdown" class="scrollBar_view_xy">
                    <el-dropdown-item v-for="(item,index) in iconList">
                        <i class="iconfont" style="
                        font-size: 25px
                        " :class="item" @click="config.name = item,getRender()"></i>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="chartDivConfig selViewConfig transfromConfig">
            <span class="span_til">旋转和翻转</span>
            <el-select v-model="config.transform.type" placeholder="旋转和翻转"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in transfromList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="config.transform.type === 'rotate'">
            <span class="span_til">旋转角度</span>
            <el-slider class="slider" v-model="config.transform.rotate" :min="0" :max="360" ></el-slider>
        </div>
        <div class="chartDivConfig checkViewConfig" v-if="config.transform.type === 'flip'">
            <el-checkbox v-model="config.transform.flipVertically" @change="getRender">垂直翻转</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig" v-if="config.transform.type === 'flip'">
            <el-checkbox v-model="config.transform.flipHorizontally" @change="getRender">水平翻转</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">颜色</span>
            <el-color-picker v-model="config.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">上浮颜色</span>
            <el-color-picker v-model="config.hoverColor" show-alpha @change="getRender"></el-color-picker>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye0
     @date 2020/4/24 8:04 下午
     */
    import iconList from "../../../iocnfont/iconClass";
    export default {

        name: 'icon_config',
        components: {},
        data() {
            return {
                iconList:iconList.iconList,
                transfromList: [
                    {value: 'flip', label: '翻转'},
                    {value: 'rotate', label: '旋转'}
                ],
            }
        },
        computed: {
            config() {
                return this.$store.state.designer.chart.setting.params;
            },
            groupDpList() {
                if (this.type === 'screen') {
                    return this.$store.state.designer.groupDpList
                }
            },
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },

        },
        mounted() {
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    @import "../../../iocnfont/iconfont.css";

    .icon_config {
        .el-select-dropdown__item {
            display: inline-block;
            width: 24%;
            text-align: center;
        }
    }
    .el-dropdown-menu{
        height: 300px !important;
        width: 305px !important;
        overflow: auto;
        overflow-x: hidden;
        >li{
            display: inline-block;
            width: 40px;
            padding: 0;
            text-align: center;
            >i{
                margin: 0;

            }
        }
    }
    .transfromConfig{
        .el-select-dropdown{
            ul{
                li{
                    width: 100%;
                    text-align: left;
                    margin: 0;
                }
            }
        }
    }
    .slider{
        width: 65%;
        display: inline-block;
    }

</style>
